import { Outlet } from "react-router-dom";
import { MeBottomNav, MeHeader } from "@/components/me/me-nav";

export function MeLayout() {
  return (
    <div className="flex h-[100dvh] flex-col overflow-hidden bg-background">
      <MeHeader />
      <main className="min-h-0 flex-1 overflow-y-auto px-4 py-6">
        <Outlet />
      </main>
      <MeBottomNav />
    </div>
  );
}
